import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { postLogDetails } from '../../../Services/APIs/appDetails';
import { submitSimUserDetails } from '../../../Services/APIs/scan';

const validationSchema = Yup.object().shape({
    first_name: Yup.string().required('First name is required'),
    last_name: Yup.string().required('Last name is required'),
    location: Yup.string().required('Location is required'),
    zip: Yup.number().required('Zipcode is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    phone: Yup.number().required('Phone number is required'),
    terms: Yup.boolean().oneOf([true], 'You must accept the terms and conditions'),
});

const AboutMeForm = ({ toggleActive }) => {
    const uid = JSON.parse(localStorage.getItem("usertpi" || "{}")).usertpi;
    const company = localStorage.getItem("company");



    const initialValues = {
        first_name: '',
        last_name: '',
        location: '',
        zip: '',
        email: '',
        phone: '',
        terms: false,
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);

        const payload = { ...values, is_form_completed: true, patient_UUID: uid, company }
        postLogDetails({ app: company, payLoad: "submitting form...", uid })
        await submitSimUserDetails(payload).then((res) => {
            if (res.status === 200) {
                localStorage.setItem("is_form", "true");
                setTimeout(() => {
                    toggleActive();
                }, 100);
            }
        }).catch((err) => {
            localStorage.setItem("is_form", "true");
            setTimeout(() => {
                toggleActive();
            }, 100);
        })
        setSubmitting(false);
    };

    return (
        <div className="white min-h-full flex items-center justify-center font-novatica p-4">
            <div className="w-full max-w-lg">
                <div className="text-left mb-8">
                    <h1 className="text-[50px] font-medium text-[#2C2D24]">About Me</h1>
                </div>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <div className="grid grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label htmlFor="first_name" className="block text-xs">Full Name</label>
                                    <Field type="text" name="first_name" placeholder="John" className="mt-1 block w-full px-3 py-2 bg-white border-2 border-[#BED0C5CC] rounded-md shadow-sm focus:outline-none focus:ring-[#7998ECCC] focus:border-[#515a74CC] focus:shadow-sm sm:text-sm" />
                                    <ErrorMessage name="first_name" component="div" className="text-red-500 text-sm mt-1" />
                                </div>
                                <div>
                                    <label htmlFor="last_name" className="block text-xs">&nbsp;</label>
                                    <Field type="text" name="last_name" placeholder="Doe" className="mt-1 block w-full px-3 py-2 bg-white border-2 border-[#BED0C5CC] rounded-md shadow-sm focus:outline-none focus:ring-[#7998ECCC] focus:border-[#515a74CC] focus:shadow-sm sm:text-sm" />
                                    <ErrorMessage name="last_name" component="div" className="text-red-500 text-sm mt-1" />
                                </div>
                            </div>

                            <div className="mb-4">
                                <label htmlFor="location" className="block text-xs">Location</label>
                                <Field as="select" name="location" className="mt-1 block w-full px-3 py-2 bg-white border-2 border-[#BED0C5CC] rounded-md shadow-sm focus:outline-none focus:ring-[#7998ECCC] focus:border-[#515a74CC] focus:shadow-sm sm:text-sm">
                                    <option value="">Select a location</option>
                                    <option value="New York, United States">New York, United States</option>
                                </Field>
                                <ErrorMessage name="location" component="div" className="text-red-500 text-sm mt-1" />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="zip" className="block text-xs">Zipcode</label>
                                <Field type="number" name="zip" placeholder="Zipcode" className="mt-1 block w-full px-3 py-2 bg-white border-2 border-[#BED0C5CC] rounded-md shadow-sm focus:outline-none focus:ring-[#7998ECCC] focus:border-[#515a74CC] focus:shadow-sm sm:text-sm" />
                                <ErrorMessage name="zip" component="div" className="text-red-500 text-sm mt-1" />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="email" className="block text-xs">Email</label>
                                <Field type="email" name="email" placeholder="Email" className="mt-1 block w-full px-3 py-2 bg-white border-2 border-[#BED0C5CC] rounded-md shadow-sm focus:outline-none focus:ring-[#7998ECCC] focus:border-[#515a74CC] focus:shadow-sm sm:text-sm" />
                                <ErrorMessage name="email" component="div" className="text-red-500 text-sm mt-1" />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="phone" className="block text-xs">Phone Number</label>
                                <div className="mt-1 flex rounded-md shadow-sm">
                                    <Field as="select" name="countryCode" className="block w-1/4 px-3 py-2 bg-white border-2 border-[#BED0C5CC] rounded-l-md focus:outline-none focus:ring-[#7998ECCC] focus:border-[#515a74CC] focus:shadow-sm sm:text-sm">
                                        <option>+1</option>
                                    </Field>
                                    <Field type="number" name="phone" placeholder="Phone Number" className="block w-3/4 px-3 py-2 bg-white border-2 border-[#BED0C5CC] rounded-r-md focus:outline-none focus:ring-[#7998ECCC] focus:border-[#515a74CC] focus:shadow-sm sm:text-sm" />
                                </div>
                                <ErrorMessage name="phone" component="div" className="text-red-500 text-sm mt-1" />
                            </div>

                            <div className="mb-6">
                                <label className="flex items-center">
                                    <Field type="checkbox" name="terms" className="h-4 w-4 text-[#7998EC1A] focus:ring-[#7998ECCC] focus:border-[#515a74CC] border-[#BED0C5CC] rounded" />
                                    <span className="ml-2 text-sm text-black">I accept the Terms and Conditions</span>
                                </label>
                                <ErrorMessage name="terms" component="div" className="text-red-500 text-sm mt-1" />
                            </div>

                            <button type="submit" disabled={isSubmitting} className=" w-fit flex justify-center py-3 px-6 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#2C2D24]">
                                Submit to See Your New Smile
                            </button>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default AboutMeForm;
